import React from 'react';
import {convertUTCDateToLocalDate} from '../../utils/localtime.js'
import { styles } from '../../styles/styles.js';
import { fmt, isNum, EM_DASH } from '../../utils/format.js';


export function Winner({fixture, name, team1, team2}) {
    if (!fixture) return null;

    // Nine branches below each dereferenced fixture.ratings.home_pre_elo with no
    // guard of any kind — not on the blob, not on the field. Reached from the
    // Recents and Head-to-Head cards, whose fixtures come straight off the list
    // endpoint. Derived once here so every branch is safe by construction.
    const homeElo = fmt(fixture.ratings?.home_pre_elo, 0);
    const awayElo = fmt(fixture.ratings?.away_pre_elo, 0);
    const homePts = isNum(fixture.home_points) ? fixture.home_points : EM_DASH;
    const awayPts = isNum(fixture.away_points) ? fixture.away_points : EM_DASH;

    if ((fixture.home_team === name && fixture.winner === name))
        return (
            <div style={styles.text}>
                <p>
                  {convertUTCDateToLocalDate(fixture.game_time)} <b>{fixture.home_team} ({homeElo}) {homePts}</b> vs {awayPts}  {fixture.away_team} ({awayElo})  
                </p>
            </div>
        );
    else if ((fixture.home_team === name && fixture.loser === name))
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} {fixture.home_team} ({homeElo}) {homePts} vs <b>{awayPts} {fixture.away_team} ({awayElo})</b>  
                </p>
            </div>
        );
    else if ((fixture.away_team === name && fixture.winner === name))
        return (
            <div style={styles.text}>
                 <p> 
                   {convertUTCDateToLocalDate(fixture.game_time)} <b> {fixture.away_team} ({awayElo}) {awayPts} </b> @ {homePts} {fixture.home_team} ({homeElo})  
                </p>
            </div>
        );
    else if ((fixture.away_team === name && fixture.loser === name))
        return (
            <div style={styles.text}>
                 <p>
                  {convertUTCDateToLocalDate(fixture.game_time)} {fixture.away_team} ({awayElo}) {awayPts}  @ <b>{homePts} {fixture.home_team} ({homeElo})</b>  
                </p>
            </div>
        );
    else if ((fixture.away_team === name))
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} {fixture.away_team} ({awayElo}) {awayPts}  @ {homePts} {fixture.home_team} ({homeElo})  
                </p>
            </div>
        );
    else if ((fixture.home_team === name))
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} {fixture.home_team} ({homeElo})  {homePts} vs {awayPts}  {fixture.away_team} ({awayElo}) 
                </p>
            </div>
        );
    else if (team1 && team2 && fixture.home_points > fixture.away_points)
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} <b>{fixture.home_team} ({homeElo}) {homePts}</b> vs {awayPts}  {fixture.away_team} ({awayElo})
                </p>
            </div>

        );
    else if (team1 && team2 && fixture.home_points < fixture.away_points)
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} {fixture.home_team} ({homeElo}) {homePts} vs <b>{awayPts} {fixture.away_team} ({awayElo})</b>
                </p>
            </div>
        )
    else if (team1 && team2 && fixture.home_points === fixture.away_points)
        // A drawn game reached here and rendered an unlabelled row, visually
        // identical to an unplayed one. `fixture.winner` and `fixture.loser` are
        // both null on a draw, so every branch above keyed on them falls through
        // to here — the result was known and simply never stated.
        return (
            <div style={styles.text}>
                 <p>
                   {convertUTCDateToLocalDate(fixture.game_time)} <b>DRAW</b> {fixture.home_team} ({homeElo}) {homePts} vs {awayPts} {fixture.away_team} ({awayElo})
                </p>
            </div>
        )
    else
            return (
                <div style={styles.text}>
                     <p>
                       {convertUTCDateToLocalDate(fixture.game_time)} {fixture.home_team} ({homeElo}) {homePts} vs {awayPts} {fixture.away_team} ({awayElo})
                    </p>
                </div>
            )
}

export default Winner